import {AfterViewInit, Component, ElementRef, NgZone, ViewChild} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {filter, Subscription} from 'rxjs';

@Component({
    selector: 'app-matrimonial-home',
    templateUrl: './matrimonial-home.component.html',
    styleUrls: ['./matrimonial-home.component.css']
})
export class MatrimonialHomeComponent implements AfterViewInit {
    @ViewChild('parentSection') parentSection!: ElementRef;
    private routerSub!: Subscription;

    mode: 'approved' | 'pending' = 'approved';
    userRole: any;
    userGroup: any;
    userChapter: any;

    constructor(private ngZone: NgZone, private router: Router) {
    }

    ngOnInit(): void {
        this.userRole = JSON.parse(sessionStorage.getItem('rolesPermission') || '{}');
        this.userGroup = sessionStorage.getItem('userGroup') || '{}';
    }

    ngAfterViewInit() {

        this.routerSub = this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(() => {
                this.removeRanaBackground();
            });


        const collapseOne = document.getElementById('collapseOne');
        const collapseTwo = document.getElementById('collapseTwo');

        if (collapseOne) {
            collapseOne.addEventListener('shown.bs.collapse', () => {
                this.ngZone.run(() => {
                    this.mode = 'approved';
                    console.log('Switched to approved mode');
                });
            });
        }

        if (collapseTwo) {
            collapseTwo.addEventListener('shown.bs.collapse', () => {
                this.ngZone.run(() => {
                    this.mode = 'pending';
                    console.log('Switched to pending mode');
                });
            });
        }
    }

    /** Called by child when viewing profile */
    addRanaBackground() {
        if (this.parentSection) {
            this.parentSection.nativeElement.classList.add('section-background-profile');
        }
    }

    /** Called when leaving profile or switching mode */
    removeRanaBackground() {
        if (this.parentSection) {
            this.parentSection.nativeElement.classList.remove('section-background-profile');
        }
    }

    ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    onProfileModeChange(mode: 'list' | 'detail' | 'form') {
        if (mode === 'detail') {
            this.addRanaBackground();
        } else {
            this.removeRanaBackground();
        }
    }
}
